// Single source of truth for "log this session out", regardless of what
// triggered it — a 401 for a suspended account (see authGuard.js) is the
// first caller, but any future forced-logout reason can reuse this.
let loggingOut = false;

export function forceLogout({ message } = {}) {
  if (loggingOut) return; // several in-flight requests can all 401 at once
  loggingOut = true;
  localStorage.removeItem("accessToken");
  if (message) window.alert(message);
  window.location.href = "/login";
}
